export const openMobileMenu = (e) => {
    const wrap = e.target.closest('.mobile-menu-wrap');
    const navwrap = wrap ? wrap.querySelector('.mobile-menu-nav-wrap') : false;
    if(navwrap){
        navwrap.classList.add('active');
    }
}
export const closeMobileMenu = (e) => {
    const wrap = e.target.closest('.mobile-menu-wrap');
    const navwrap = wrap ? wrap.querySelector('.mobile-menu-nav-wrap') : false;

    if(navwrap){
        /* Reset Menu state */
        resetMobileMenu();
    }
}
export const resetMobileMenu = () => {
    const navwrap = document.querySelector('.mobile-menu-nav-wrap');
    if(navwrap){
        let submenuOpen = navwrap.querySelector('.sub-menu-open');
        if( submenuOpen ){
            Array.from(submenuOpen).forEach(elem => {
                elem.classList.remove('sub-menu-open');
                let open = elem.querySelectorAll('.open');
                if(open){
                    Array.from(open).forEach(sub => {
                        sub.classList.remove('open');
                    });
                }
            });
        }
        navwrap.classList.remove('active');
    }
}
export const mobileSubmenuToggle = (e) => {
    const li = e.target.tagName == 'LI' ? e.target : e.target.closest('li');
    const mobileNavbar = li.closest('.navbar-nav.mobile');
    if(mobileNavbar){
        mobileNavbar.classList.toggle('sub-menu-open');
        li ? li.classList.toggle('open') : false;
    }
}